import React, { useState, useEffect } from 'react';
import { Cookie, Shield } from 'lucide-react';
import { Link } from 'react-router-dom';
import { updateConsent } from '../lib/track';

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    const cookieConsent = localStorage.getItem('frelon33-cookie-consent');
    if (!cookieConsent) {
      setTimeout(() => setIsVisible(true), 1500);
    }
  }, []);

  const finish = (choice) => {
    localStorage.setItem('frelon33-cookie-consent', choice);
    updateConsent(choice === 'accepted');
    // Prévient les autres composants (ex : la pile de contact flottante)
    window.dispatchEvent(new Event('frelon33-consent-changed'));
    setIsClosing(true);
    setTimeout(() => {
      setIsVisible(false);
      setIsClosing(false);
    }, 300);
  };

  if (!isVisible) return null;

  return (
    <div
      className={`fixed bottom-0 left-0 right-0 z-[70] transition-all duration-300 ${
        isClosing ? 'transform translate-y-full opacity-0' : 'transform translate-y-0 opacity-100'
      }`}
      role="dialog"
      aria-label="Gestion du consentement aux cookies"
      data-testid="cookie-banner"
    >
      <div className="frelon-glass backdrop-blur-20 border-t border-white/20 shadow-2xl">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5">
          <div className="flex flex-col lg:flex-row items-start lg:items-center gap-5">

            <div className="flex items-start space-x-4 flex-1">
              <div className="bg-gradient-to-r from-green-100 to-yellow-100 p-3 rounded-full flex-shrink-0">
                <Cookie className="h-6 w-6 text-green-600" />
              </div>
              <div className="flex-1">
                <h3 className="text-lg font-bold text-gray-900 mb-1 flex items-center">
                  <Shield className="h-5 w-5 text-green-600 mr-2" />
                  Votre vie privée
                </h3>
                <p className="text-gray-700 leading-relaxed text-sm">
                  <strong className="frelon33-brand">Frelon33™</strong> utilise des cookies de mesure
                  d'audience et de publicité (Google) pour améliorer votre expérience et mesurer nos
                  campagnes. Vous pouvez accepter ou refuser. Aucun cookie non essentiel n'est déposé
                  sans votre accord.{' '}
                  <Link to="/politique-confidentialite" className="text-green-600 hover:text-green-700 font-medium underline">
                    En savoir plus
                  </Link>
                </p>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-3 w-full lg:w-auto">
              <button
                onClick={() => finish('declined')}
                className="frelon-btn frelon-btn-secondary px-6 py-3 font-semibold rounded-xl w-full sm:w-auto text-gray-700 border border-gray-300 hover:bg-gray-50"
                data-testid="cookie-decline-button"
              >
                Refuser
              </button>
              <button
                onClick={() => finish('accepted')}
                className="frelon-btn frelon-btn-primary px-6 py-3 text-white font-semibold rounded-xl w-full sm:w-auto"
                data-testid="cookie-accept-button"
              >
                Accepter
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
